import i18n from 'i18next';

import { referralTranslations } from './index';

/**
 * Registers the Referral domain translations into the shared i18next instance.
 * Called once at app bootstrap.
 */
export const registerReferralTranslations = (): void => {
  Object.entries(referralTranslations).forEach(([language, resources]) => {
    i18n.addResourceBundle(language, 'referral', resources, true, true);
  });
};

/**
 * Checks whether the Referral translations are already loaded for a language.
 *
 * @param language - Language to check (defaults to the current i18n language)
 * @returns True when the referral bundle is present
 */
export const areReferralTranslationsLoaded = (language?: string): boolean => {
  const lng = language || i18n.language;
  return i18n.hasResourceBundle(lng, 'referral');
};
